// const ROOT = "http://47.87.141.82";
const ROOT = "https://buybuygenuine.com";
// const ROOT = "https://cuteng-dx.zhiqiyf.com";
/**
 * 全局接口请求根域名
 */
export const API_ROOT = ROOT;

// 商城类型 - 空-默认国内普通商城  foreign-商城平台 (地址管理不一样 账号登录注册等)
export const SHOP_TYPE = ""; // ‘’ || 'foreign'
/**
 * 测试用户的 用户ID  token
 */
export const MOCK_USER_ID = "370";
export const MOCK_USER_TOKEN = "d0a8427b60";
